import CardSystem from '../CardSystem';
import ITask from '../../../Utility/Task/ITask';
import GameObject from '../../../GameObject/GameObject';
import Text from '../../../Prototype/Text';
import Point from '../../../Utility/Point';
import Game from '../../../Game';
import Container from '../../../Prototype/Container';
import AnimationComponent from '../../../Component/Animation';
import { delay } from '../../../Utility/Task/TaskQueue';
import { StartAnimation } from '../../Animation/AnimationHelper';
import Sprite from '../../../Prototype/Sprite';
import FireworksEffect from '../../../Prototype/Effect/FireworksEffect';
import { Random } from '../../../Utility/Random';
import TransformComponent from '../../../Component/Transform';
import { StartAudio } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import {
    AUDIO_WIN_SEQUENCE_FIREWORKS,
    AUDIO_WIN_SEQUENCE_JINGLE,
} from '../../Audio';
import { DragonbonesAnimationEvent } from '../../../Component/Dragonbones';

export default class LevelCompleteTask implements ITask<CardSystem> {
    public *execute(system: CardSystem): IterableIterator<number> {
        const container = GameObject.Instantiate(Container, {
            relativePosition: new Point(0.5, 0.5),
        });

        const textCongratulations = GameObject.Instantiate(Text, {
            text: Game.locale.getText('Congratulations'),
            position: new Point(0, -120),
            scale: new Point(0.2, 0.2),
            anchor: new Point(0.5, 0.5),
            style: Game.style.getStyle('win_sequence.congratulations'),
            alpha: 0,
        });

        const textYouWin = GameObject.Instantiate(Text, {
            text: Game.locale.getText('YouWin'),
            position: new Point(0, 40),
            scale: new Point(0.2, 0.2),
            anchor: new Point(0.5, 0.5),
            style: Game.style.getStyle('win_sequence.you_win'),
            alpha: 0,
            bounds: new Point(1024, 300)
        });

        const raysWhite = GameObject.Instantiate(Sprite, {
            texture: 'RaysWhite',
            anchor: new Point(0.5, 0.5),
            scale: new Point(1.7, 1.7),
            alpha: 0.8,
        });

        const raysBlue = GameObject.Instantiate(Sprite, {
            texture: 'RaysWhite',
            anchor: new Point(0.5, 0.5),
            scale: new Point(2.0, 2.0),
            alpha: 0.8,
            tint: 0x1cefff
        });

        container.addChild(raysBlue);
        container.addChild(raysWhite);

        const fireworksContainer = GameObject.Instantiate(Container);
        container.addChild(fireworksContainer);

        container.addChild(textCongratulations);
        container.addChild(textYouWin);

        textCongratulations.addComponent(AnimationComponent);
        textYouWin.addComponent(AnimationComponent);
        raysWhite.addComponent(AnimationComponent, {
            clipName: 'RayRotate',
            playOnStart: true,
            meta: { rotationSpeed: 0.005 },
        });
        raysBlue.addComponent(AnimationComponent, {
            clipName: 'RayRotate',
            playOnStart: true,
            meta: { rotationSpeed: -0.004 },
        });

        // Fireworks:
        fireworksContainer.addChild(this.addFireworks());
        fireworksContainer.addChild(this.addFireworks());
        fireworksContainer.addChild(this.addFireworks());

        system.scene.addGameObject(container);

        StartAudio(system.scene, AUDIO_WIN_SEQUENCE_JINGLE, AudioTrackType.SFX);

        StartAudio(
            system.scene,
            AUDIO_WIN_SEQUENCE_FIREWORKS,
            AudioTrackType.SFX,
            { loop: true }
        );

        StartAnimation(textCongratulations, 'TextPopIn');

        yield* delay(300);

        fireworksContainer.addChild(this.addFireworks());
        fireworksContainer.addChild(this.addFireworks());
        fireworksContainer.addChild(this.addFireworks());

        StartAnimation(textYouWin, 'TextPopIn');

        yield* delay(1500);

        StartAnimation(textCongratulations, 'AlphaText', {
            startAlpha: 1,
            endAlpha: 0,
            duration: 150,
        });

        yield* delay(50);

        StartAnimation(textYouWin, 'AlphaText', {
            startAlpha: 1,
            endAlpha: 0,
            duration: 150,
        });

        yield* delay(250);
    }

    private addFireworks(): GameObject {
        const fireworks = GameObject.Instantiate(FireworksEffect, {
            position: new Point(
                Random.value(-400, 400),
                Random.value(-200, 200)
            ),
            scale: new Point(Random.value(1.2, 1.8)),
        });

        fireworks.on(DragonbonesAnimationEvent.COMPLETE, () => {
            fireworks
                .getComponent(TransformComponent)
                .position.set(Random.value(-400, 400), Random.value(-200, 200));
            fireworks
                .getComponent(TransformComponent)
                .scale.set(Random.value(1.2, 1.8));

            Game.ticker.setTimeout(() => {
                if (fireworks && !fireworks.destroyed) {
                    StartAnimation(fireworks, 'DragonbonesDefault');
                }
            }, 50);
        });

        return fireworks;
    }
}
